import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        list: [], //table中的list显示数据
        pagination: {

        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {

    },

    mutations: {
        save(state, action) {

            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {

        platformDetail(context, payload) {
            return D.select({
                ...payload
            })
        },
        queryPlatformPage(context, payload) {
            return D.select({
                ...payload
            })
        },
        platformAdd(context, payload) {
            return D.add({
                ...payload
            })
        },
        platformDispatch(context, payload) {
            return D.add({
                ...payload
            })
        },
        platformEdit(context, payload) {
            return D.edit({
                ...payload
            })
        },

        platformDel(context, payload) {
            return D.del({
                ...payload
            })
        },

        

    }
}
